<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-col cols="12" class="mt-1 title">{{ $t("account_verified_title") }}</b-col>
      </b-col>
      <b-col cols="12">
        <b-col cols="12" class="mt-2 button-content ">
          <b-button block variant="primary" :to="{ name: 'Login' }">{{ $t("account_verified_btn_continue") }}</b-button>
        </b-col>
      </b-col>
    </b-row>
    <legal-message/>
  </b-container>
</template>

<script>
import LegalMessage from "../Components/LegalMessage"

export default {
  name: 'EmailVerified',
  components: { LegalMessage }
}

</script>

<style scoped lang="stylus">
@import "../Styles/security_styles.styl"

</style>
